import React, {Dispatch, FC, SetStateAction, useContext, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {AsideMenu} from './AsideMenu'
import {useSelector} from 'react-redux'
import {ISettingTypeState} from 'src/app/modules/siteSettings/components/settings'
import {isEmpty, iteratee} from 'lodash'
import {imageBaseUrl} from 'src/cms/helpers/constants'
import CheckPermissions from 'src/app/modules/common/checkPermission'
import {Button, Drawer} from 'antd'
import {ActiveMenuContex} from '../../MasterLayout'
import {OnboardingLogo} from '../header/OnboardingLogo'

const AsideDefault: FC = () => {
  const {config, classes} = useLayout()
  const {aside} = config
  const [logo, setLogo] = useState('')
  const settingTypeData: ISettingTypeState = useSelector((state: any) => state.settingType)
  const activeMenu: any = useContext(ActiveMenuContex)
  useEffect(() => {
    if (!isEmpty(settingTypeData?.backendData)) {
      settingTypeData?.backendData &&
        settingTypeData?.backendData['Theme settings']?.map((item: any) => {
          if (item?.name === 'mainLogo') {
            setLogo(item?.value)
          }
        })
    }
  }, [settingTypeData])
  // const [open, setOpen] = useState(false);

  // const showDrawer = () => {
  //   setOpen(true);
  // };

  const onClose = () => {
    activeMenu.setOpen(false)
  }
  return (
    <>
      <Drawer
        title={
          <div className='d-flex align-items-center justify-content-between'>
            <span className='amnil-drawer-title'>Main menu</span>
            <OnboardingLogo height={20} />
          </div>
        }
        onClose={onClose}
        open={activeMenu.open}
        placement='left'
        width={360}
        className='gibl-aside-drawer'
        styles={{body: {padding: '0.75rem 0.85rem 1.5rem'}}}
      >
        {/* begin::Aside menu */}
        {/* No wrapper div here: the drawer body -> menu -> list height chain
            has to be unbroken for the module list to scroll, and a plain
            height:auto div in between collapses it (the list then overflows a
            body that clips, with no scrollbar anywhere). */}
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
        {/* end::Aside menu */}
      </Drawer>
    </>
  )
}

export {AsideDefault}
